import React, { useEffect, useRef } from 'react';
import PageLayout from '../../../components/PageLayout/CarelonRx';
import { useFlow } from '../../../contexts/FlowContext';
import SecureSessionService from '../../../services/session/SecureSessionService';
import { ORIGINAL_CLIENT_REDIRECT_URL } from '../../../config';
import '../../../styles/CarelonRx/modal.css';

const ErrorPage: React.FC = () => {
  const { resetFlow } = useFlow();
  const modalRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const errorCode = urlParams.get('code');
    const errorMessage = urlParams.get('message');
    
    if (errorCode) {
      console.error(`Authentication error - Code: ${errorCode}, Message: ${errorMessage || 'No message provided'}`);
    } else {
      console.error('Authentication error occurred: unknown');
    }

    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleReturnToLogin();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handleReturnToLogin = () => {
    SecureSessionService.clearSession();
    sessionStorage.clear();
    
    if (ORIGINAL_CLIENT_REDIRECT_URL) {
      window.location.replace(ORIGINAL_CLIENT_REDIRECT_URL);
    } else {
      console.error('VITE_ORIGINAL_CLIENT_REDIRECT_URL is not defined');
      window.location.replace('/');
    }
  };

  return (
    <PageLayout bannerTitle="">
      <div className="login-page-container">
        <div className="login-left-panel">
          <div 
            className="modal-overlay" 
            style={{ position: 'fixed' }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="error-modal-title"
            aria-describedby="error-modal-message"
          >
            <div 
              className="modal-content" 
              ref={modalRef}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 
                id="error-modal-title" 
                className="modal-title"
              >
                Unable to Sign In
              </h2>
              <p 
                id="error-modal-message" 
                className="modal-message"
              >
                We are unable to complete your sign-in request at this time. Please try again in a few minutes.
              </p>
              <div className="modal-actions">
                <button 
                  ref={buttonRef}
                  onClick={handleReturnToLogin} 
                  className="modal-btn-stay"
                  aria-label="Return to login page"
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ErrorPage;
